import { createAction } from '@reduxjs/toolkit'
import type { ActivityHistoryAction } from '@store/reducers/manager/activityHistory/types'

type AddActivityHistoryActionsPayload = {
  actions: ActivityHistoryAction[]
}

export type PreviewSagaPayload = {
  id: number
}

export type RestoreSagaPayload = {
  id: number
}

type ActivityHistorySetSelectedActionPayload = {
  id: string
}

export const activityHistoryActions = {
  setIsLoading: createAction<boolean>('ACTIVITY_HISTORY_SET_IS_LOADING'),
  setIsLoaded: createAction<boolean>('ACTIVITY_HISTORY_SET_IS_LOADED'),
  fetchActionsSaga: createAction('ACTIVITY_HISTORY_FETCH_ACTIONS_SAGA'),
  addActivityHistoryActions: createAction<AddActivityHistoryActionsPayload>(
    'ACTIVITY_HISTORY_ADD_ACTIONS'
  ),
  setActivityHistorySelectedAction: createAction<number>(
    'ACTIVITY_HISTORY_SET_SELECTED_ACTION'
  ),
  setActivityHistoryTotal: createAction<number>('ACTIVITY_HISTORY_SET_TOTAL'),
  previewSaga: createAction<PreviewSagaPayload>(
    'ACTIVITY_HISTORY_SET_PREVIEW_SAGA'
  ),
  restoreSaga: createAction<RestoreSagaPayload>(
    'ACTIVITY_HISTORY_RESTORE_SAGA'
  ),
  setActivityHistorySetSelectedAction:
    createAction<ActivityHistorySetSelectedActionPayload>(
      'ACTIVITY_HISTORY_SET_SELECTED_ACTION'
    ),
  resetActivityHistory: createAction('ACTIVITY_HISTORY_RESET'),
}
